export default __webpack_public_path__ + "static/SR China - ISO 22000 - Certificate-354a786702620b15b8d434283e956104.pdf";